import { Component, inject } from '@angular/core';
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { RouteTitleService } from '@core/router/route-title.service';
import { rxEffects } from '@rx-angular/state/effects';
import { ClientState } from '@shared/state/client.state';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './root.html',
    styleUrl: './root.scss',
})
export class Root {
    readonly #router: Router = inject(Router);
    readonly #effects = rxEffects();
    readonly #clientState: ClientState = inject(ClientState);
    // eslint-disable-next-line no-unused-private-class-members
    readonly #routeTitleService: RouteTitleService = inject(RouteTitleService);

    constructor() {
        this.#effects.register(this.#router.events.pipe(filter((event: Event) => event instanceof NavigationEnd)), () =>
            this.#clientState.resetErrors(),
        );
    }
}
